export const GLOBAL_TSR = '$_TSR'
export declare const GLOBAL_SEROVAL: '$R'
export const TSR_SCRIPT_BARRIER_ID = '$tsr-stream-barrier'
